<template>
  <div>
    <hb-modal
      size="large"
      title="Remove Service"
      v-model="showRemoveServiceConfirmation"
      confirmation
      show-help-link
    >
      <template v-slot:content>
        <hb-form class="start-service" multiple label="From" required>
        <hb-radio-group v-model="serviceEnd">
          <hb-radio
            :label="`Current Billing Period: ${billingPeriods.current && $options.filters.formatDate(
              billingPeriods.current.start
            )} - ${billingPeriods.current && $options.filters.formatDate(billingPeriods.current.end)}`"
            value="current"
            :disabled = "!isRemovalProrated"
          ></hb-radio>

          <span v-if="billingPeriods.future === undefined || !billingPeriods.future" >
                <loader color="#00b2ce" size="20px" class="inline-loader"></loader>
          </span>
          <hb-radio v-else
            :label="`Next Billing Period: ${billingPeriods.future && $options.filters.formatDate(
              billingPeriods.future[0].start
            )} - ${billingPeriods.future && $options.filters.formatDate(billingPeriods.future[0].end)}`"
            value="next"
          ></hb-radio>

        </hb-radio-group>
      </hb-form>
        <div class="py-4 px-6">
          <!-- You are about to remove the applied service. This change will affect
          upcoming invoices on this account.
          <br /><br /> -->
          Are you sure you want to remove the service?
        </div>
      </template>
      <template v-slot:actions>
        <hb-btn color="primary" @click="removeService" :loading="setLoading">Remove Service</hb-btn>
      </template>
    </hb-modal>
    
		<add-new-service v-if="showAddServiceModal" v-model="showAddServiceModal" :contact="contact" :lease="lease" @close="closeAddServiceModal" />

    <all-services :displayRemoveOption="(is_closed || isAuctioned) ? false : true" :services="services.future" />
    <all-services :displayRemoveOption="(is_closed || isAuctioned) ? false : true" :services="services.present" />

    <div class="hb-text-light text-body-2 pb-2" style="padding-top: 1px;">
      <hb-tooltip>
        <template slot="item">
          <span style="border-bottom: thin dashed; cursor: pointer">
            Past Services ({{ services.past && services.past.length }})
          </span>
        </template>
        <template slot="body">
          <all-services
            :services="services.past"
            durationPeriodColor="#fff"
            displayNoServiceMessage
          />
        </template>
      </hb-tooltip>
    </div>

    <hb-link @click="addService" v-if="!(is_closed || isAuctioned)">+ Add a Service</hb-link>
  </div>
</template>

<script type="text/babel">
import api from "../../assets/api.js";
import AllServices from "./AllServices.vue";
import AddNewService from "./AddNewService.vue";
import moment from 'moment';
import { EventBus } from '../../EventBus';
import { notificationMixin } from  '../../mixins/notificationMixin.js';

export default {
  name: "ServicesInfo",
  mixins: [notificationMixin],
  data() {
    return {
      services: {
        past: [],
        present: [],
        future: []
      },
      showAddServiceModal: false,
      showRemoveServiceConfirmation: false,
			removingService: null,
      billingPeriods: {},
      serviceEnd: "current",
      isRemovalProrated : true,
      setLoading:false
    };
  },

  props: {
    lease: {
      type: Object,
      required: true,
    },
    contact: {
      type: Object,
      required: true
    }
  },

  components: {
    AllServices,
		AddNewService
  },

  async created() {
  	EventBus.$on('closeAddServiceModal', this.closeAddServiceModal);
  	EventBus.$on('removeService', this.openRemoveServiceConfirmation);
  	EventBus.$on('fetchServices', this.fetchServices);

    await this.fetchServices();
    await this.fetchNextBillingPeriods();
  },

  destroyed() {
    EventBus.$off('closeAddServiceModal', this.closeAddServiceModal);
  	EventBus.$off('removeService', this.openRemoveServiceConfirmation);
  	EventBus.$off('fetchServices', this.fetchServices);
  },

  computed: {
    is_closed(){
      return moment(this.lease.end_date).startOf('day') <= moment().startOf('day');
    },
    isAuctioned(){
      return ( ['auction_payment','move_out'].includes(this.lease.auction_status))
    }
  },

  methods: {
    closeAddServiceModal() {
      this.showAddServiceModal = false;
    },
    addService() {
      this.showAddServiceModal = true;
    },
		openRemoveServiceConfirmation({service, leaseId}) {
      if(leaseId === this.lease.id){
			  this.removingService = service;
			  this.showRemoveServiceConfirmation = true;
        if(service.prorate_out === 0){
          this.serviceEnd = "next";
          this.isRemovalProrated = false;
        }else{
          this.serviceEnd = "current";
          this.isRemovalProrated = true;
        }
      }
		},
		async removeService() {
      try {
        this.setLoading = true;
        let res = await api.delete(
          this,
          `${api.LEASES}/${this.lease.id}/services/${this.removingService.id}?serviceEnd=${this.serviceEnd}`
        );

        this.showMessageNotification({ type: "success", description: "Removed Service" });
        await this.fetchServices();
      } catch(err) {
        this.showMessageNotification({ description: err });
      }
      this.setLoading=false;
			this.showRemoveServiceConfirmation = false;
		},
    async fetchServices() {
      try {
        let res = await api.get(
          this,
          `${api.LEASES}/${this.lease.id}/all-services`
        );

        let { services } = res;
        services.past = services.past.filter(a => a.recurring === 1);
        services.present = services.present.filter(a => a.recurring === 1);
        services.future = services.future.filter(a => a.recurring === 1);
        this.services = services;
      } catch(err) {
        console.log('err ', err);
      }
    },
    async fetchNextBillingPeriods() {
      try {
        const res = await api.get(
          this,
          `${api.LEASES}/${this.lease.id}/billing_periods?future_months=12`
        );
        this.billingPeriods = res.billing_months;
        this.billingPeriods.current.start = moment(this.billingPeriods.current.start).add(1, 'days').format("YYYY-MM-DD");
      } catch(err) {
        console.log('err ', err);
        this.showMessageNotification({ description: err });
      }
    }
  },
};
</script>

<style>
</style>